import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertPaymentDetail } from 'functions';
import { DeductionService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { PaymentDetail } from 'types';

type DeductionDetailParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
    referenceId?: string,
    voucherId?: string,
    adjustmentIdentityKey?: string,
} & SerializableParam;

export const deductionDetails = selectorFamily<PaymentDetail, DeductionDetailParams>({
    key: 'deductionDetails',
    get: ({ accountId, vendorId, invoiceId, referenceId, voucherId, adjustmentIdentityKey }) =>
        async ({ get }) => {
            get(refreshState(deductionDetails({ accountId, vendorId, invoiceId, referenceId, voucherId, adjustmentIdentityKey }).key));
            if (get(isAuthenticated) && accountId && invoiceId) {
                const service = new DeductionService();
                const data = await service.getDeductionDetails(accountId, vendorId, invoiceId, referenceId, voucherId, adjustmentIdentityKey);
                return convertPaymentDetail(data);
            }
            return {} as PaymentDetail;
        }
});

export const useDeductionDetails = (accountId: string, vendorId: string, invoiceId: string, referenceId?: string, voucherId?: string, adjustmentIdentityKey?: string) => useRecoilValue(deductionDetails({ accountId, vendorId, invoiceId, referenceId, voucherId, adjustmentIdentityKey }));

export const useRefreshDeductionDetails = (accountId: string, vendorId: string, invoiceId: string, referenceId?: string, voucherId?: string, adjustmentIdentityKey?: string) => useSetRefreshState(deductionDetails({ accountId, vendorId, invoiceId, referenceId, voucherId, adjustmentIdentityKey }));
